import { settlementOptions } from "../../../lib/constants";
import { unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import ValueFinder from "../../shared/ValueFinder";

const SettlementsCard = ({ item }) => {
  const { settlement, account } = item;

  return (
    <div className="bg-primary-10 py-2 px-4 rounded-[16px] flex flex-col gap-1  items-center shadow-lg border  ">
      <div className="flex justify-between items-center w-full   ">
        <div className=" flex-center items-top gap-1  text-dark  ">
          <p>تسویه با شناسه </p>

          <span>{settlement?.id ?? "-"}</span>
        </div>
      </div>

      <div className="mt-2  flex flex-col gap-1 items-center w-full text-[14px]">
        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            مبلغ تسویه(ریال)
          </label>
          {settlement.amount.toLocaleString() ?? "-"}
        </div>
        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            تاریخ درخواست
          </label>
          <div className="flex ">
            <div>{unixToPersianDay(settlement.creation_time) ?? "-"}</div>
            <div>{unixToPersianTime(settlement.creation_time) ?? "-"}</div>
          </div>
        </div>
        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            شبای مقصد
          </label>
          <div className="flex-center ">{account.system_account ? "وندا ولت" : account.iban}</div>
        </div>
      </div>
      <hr className="bg-neutral-20 h-[2px] text-neutral-20 w-full" />
      <div className="flex gap-2 mt-auto flex-col w-full ">
        <div className="flex justify-end gap-2 items-center w-full ">
          <ValueFinder data={settlementOptions} title={settlement.settlement_state} />
        </div>
      </div>
    </div>
  );
};

export default SettlementsCard;
